/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleHistoryManagementEditOrderDetailRequest } from './CarpsaleHistoryManagementEditOrderDetailRequest';
import type { CarpsaleHistoryManagementEditOrderUnitRequest } from './CarpsaleHistoryManagementEditOrderUnitRequest';

export type CarpsaleHistoryManagementEditOrderRequest = {
    id: number;
    invoiceMemberAddressid?: number;
    invoiceName: string;
    invoiceZip?: string;
    invoiceAddress1?: string;
    invoiceAddress2?: string;
    invoiceAddress3?: string | null;
    invoiceTel?: string;
    destinationMemberAddressid?: number;
    destinationName?: string;
    destinationZip?: string;
    destinationAddress1?: string;
    destinationAddress2?: string;
    destinationAddress3?: string | null;
    destinationTel?: string;
    deliveryType?: CarpsaleHistoryManagementEditOrderRequest.deliveryType;
    orderDetails?: Array<CarpsaleHistoryManagementEditOrderDetailRequest>;
    usePoint?: number;
    orderUnits?: Array<CarpsaleHistoryManagementEditOrderUnitRequest>;
    paymentType: CarpsaleHistoryManagementEditOrderRequest.paymentType;
    paymentLimitDate?: string | null;
    deliveryPreferredDate?: string | null;
    deliveryPreferredTime?: number | null;
    note?: string | null;
    status?: CarpsaleHistoryManagementEditOrderRequest.status;
    noteStaff?: string | null;
};

export namespace CarpsaleHistoryManagementEditOrderRequest {

    export enum deliveryType {
        STORE = 'Store',
        DELIVERY = 'Delivery',
    }

    export enum paymentType {
        BANK = 'Bank',
        C_O_D = 'C.O.D',
        DIRECT = 'Direct',
    }

    export enum status {
        INITIAL = 'initial',
        CONFIRMED = 'confirmed',
        PACKING = 'packing',
        SENTED = 'sented',
        CANCEL = 'cancel',
    }


}

